import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import type { ElementType, Ref } from 'react';
import { forwardRef, memo } from 'react';

type SvgIconOptions = {
  viewBox?: string;
  fill?: string;
};

function createSvgIcon(
  name: string,
  component: ElementType,
  options: SvgIconOptions = {},
) {
  const { viewBox, fill } = options;

  function Component(props: SvgIconProps, ref: Ref<SVGSVGElement>) {
    const { sx, ...restProps } = props;

    return (
      <SvgIcon
        ref={ref}
        sx={[
          { fill: fill === 'none' ? 'transparent' : fill },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...restProps}
        viewBox={viewBox}
        component={component}
      />
    );
  }

  Component.displayName = name;

  return memo(forwardRef(Component));
}

export default createSvgIcon;
